import { FEEDBACK_ADD_TO_CART_VARIANTS } from '../utils/mapFeedbackAddToCartVariant'

export function useFeedbackTestVariable() {
	const variant = FEEDBACK_ADD_TO_CART_VARIANTS.DEFAULT

	return { variant, enabled: false }
}
